import React from "react";
import { logout } from "../api/auth.service";
import jwtService from "../api/jwt.service";
import { authReducer, initialState } from "../reducers/AuthReducer";

const AuthContext = React.createContext({
  state: initialState,
  dispatch: () => initialState,
});

export function AuthProvider(props) {
  const [state, dispatch] = React.useReducer(authReducer, initialState);

  React.useEffect(() => {
    const token = jwtService.getItem("token");
    const user = jwtService.getItem("user");
    if (!token) {
      dispatch({ type: "LOGOUT" });
      logout();
    } else {
      dispatch({ type: "AUTH" });
      dispatch({ type: "LOAD_USER", user: JSON.parse(user) });
      jwtService.storeItem(token, "token");
    }
  }, []);

  return (
    <AuthContext.Provider value={{ state, dispatch }} {...props}>
      {props.children}
    </AuthContext.Provider>
  );
}


// 0271004762

export default function useAuth() {
  return React.useContext(AuthContext);
}
